/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-02 18:01:31
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-29 16:47:20
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/EditorPageLayout.tsx
 */
import React, { ReactNode } from 'react';
import css from './css.less';
import Element from './Element/Elements';
import { ChangeSize } from 'src/tools/customHooks';
import { useDispatch } from 'react-redux';
import { setContentWidth } from '../store';
interface IProps {
  elements?;
  topRight?: ReactNode;
  topLeft?: ReactNode;
  layoutLeftClassName?: string;
}

const Layout = (props: IProps) => {
  const { elements = [], topRight, topLeft, layoutLeftClassName } = props;
  const _d = useDispatch();
  const Ele = elements.map((i, index) => {
    return (
      <Element style={i.style} key={index}>
        {i.child}
      </Element>
    );
  });
  const contentSize = ChangeSize(
    'layouts-editorPage-editorPageContentContainer',
  );
  React.useEffect(() => {
    return () => {
      _d(setContentWidth(0));
    };
  }, []);
  React.useEffect(() => {
    _d(setContentWidth(contentSize));
  }, [contentSize]);

  return (
    <div className={css.container}>
      <div className={css.topStickContainer}>
        <div className={css.topStickLeft}>{topLeft}</div>
        <div className={css.topStickRight}>{topRight}</div>
      </div>
      <div className={css.contentContainer}>
        <div
          className={`${layoutLeftClassName} ${css.contentLeft}`}
          id='layouts-editorPage-editorPageContentContainer'>
          {Ele}
        </div>
      </div>
    </div>
  );
};
export default Layout;
